import { createSelector } from 'reselect';

import { CAMPAIGN_FILE_STATUS } from 'components/campaigns/Details/constants';
import { CAMPAIGN_FILES_STATUS, EMAIL_STATUS, LINKED_INTERVENTION } from 'constants/FilterConstants';
import { CAMPAIGN_FILE_EVENT_ENUM } from 'modules/campaignFiles/constants';
import { getUIState, getCampaignFilesByIds } from 'modules/campaignFiles/selectors';
import { getSelectedCampaign, getSelectedCampaignMode } from 'modules/campaigns/selectors/details';
import { filterRequestFormatter } from 'modules/interventions/utils';

const getRoot = state => state;

const getProps = (_, props) => props;

const getState = createSelector(getUIState, uiState => uiState.creationFiles);

export const isOpen = createSelector(getState, ({ open }) => open);

const getInitialReference = createSelector(getProps, getSelectedCampaign, (intl, campaign) => {
  const firstname = intl.formatMessage({ id: 'firstName', defaultMessage: 'First Name' });
  const lastname = intl.formatMessage({ id: 'lastName', defaultMessage: 'Last Name' });
  return `{${firstname}} {${lastname}} - ${campaign.name}`.slice(0, 80);
});

export const getInitialBulkValues = createSelector(
  getSelectedCampaign,
  getInitialReference,
  ({ mode, module, brand, dealerId }, referenceId) => ({
    mode,
    module,
    dealerId,
    referenceId,
    brandId: brand.id,
    all: false,
    campaignFileIds: [],
    excludedCampaignFileIds: [],
  })
);

const getCampaignFilesState = createSelector(getState, state => state.campaignFiles);

const getCampaignFilesIds = createSelector(getCampaignFilesState, ({ ids }) => ids);

export const getCampaignFiles = createSelector(getRoot, getCampaignFilesIds, getCampaignFilesByIds);

export const isCampaignFilesLoading = createSelector(getCampaignFilesState, ({ loading }) => loading);

export const getPage = createSelector(getCampaignFilesState, ({ page }) => page);

export const isBulkLoading = createSelector(getState, ({ bulkCreating }) => bulkCreating);

export const creatingIntervention = createSelector(getState, ({ creating }) => creating);

export const getCampaignBulkFilters = createSelector(getState, ({ filters }) => filters);

export const getCampaignBulkRequestFilters = createSelector(
  getCampaignBulkFilters,
  getSelectedCampaign,
  (filters, campaign) => {
    const forcedFilters = campaign.hasProposedWorks
      ? {
        [LINKED_INTERVENTION]: false,
        [CAMPAIGN_FILES_STATUS]: [CAMPAIGN_FILE_STATUS.ANSWERED],
      }
      : {
        [LINKED_INTERVENTION]: false,
        [EMAIL_STATUS]: [CAMPAIGN_FILE_EVENT_ENUM.RECEIVED, CAMPAIGN_FILE_EVENT_ENUM.OPENED, CAMPAIGN_FILE_EVENT_ENUM.CLICKED],
      };

    return filterRequestFormatter({
      ...filters,
      ...forcedFilters,
    });
  }
);

export const getBulkCampaignFilesParams = createSelector(
  getPage,
  getSelectedCampaignMode,
  getCampaignBulkRequestFilters,
  ({ size, number }, mode, filters) => ({
    size,
    mode,
    page: number,
    projection: 'page',
    ...filterRequestFormatter(filters),
  })
);
